import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RmConfirmationService {
    private httpError: any;
    private finished: any;
    private disabledActivate: any;

    constructor() {
        this.httpError = new BehaviorSubject<boolean>(false);
        this.finished = new BehaviorSubject<boolean>(false);
        this.disabledActivate = new BehaviorSubject<boolean>(false);
    }

    setHttpError(data) {
        this.httpError.next(data);
    }

    getHttpError() {
        return this.httpError.asObservable();
    }

    getFinished() {
        return this.finished.asObservable();
    }

    setFinished(data) {
        this.finished.next(data);
    }

    getDisableActivate() {
        return this.disabledActivate.asObservable();
    }

    setDisableActivate(data) {
        this.disabledActivate.next(data);
    }
}
